export const STUDENT_LOGO_SRC = `${import.meta.env.BASE_URL}LOGO.png`;

